import { createRouter, createWebHistory } from 'vue-router'
import AncillaryBrandView from '../components/AncillaryBrandView.vue'
import PaymentResponse from '../components/PaymentResponse.vue'
import PaymentUnsuccessful from '../components/paygate/PaymentUnsuccessful.vue'
import PaymentSuccessful from '../components/paygate/PaymentSuccessful.vue'
import TermsAndConditions from '../components/legal/TermsAndConditions.vue'
import FaqView from '../components/legal/FaqView.vue'
import SearchView from '../components/tui/SearchView.vue'

const routes = [
  {
    path: '/:id',
    name: 'AncillaryBrand',
    component: AncillaryBrandView
  },
  {
    path: '/payment-response/:id',
    name: 'PaymentResponse',
    component: PaymentResponse
  },
  {
    path: '/:id/payment-unsuccessful',
    name: 'payment-unsuccessful',
    component: PaymentUnsuccessful
  },
  {
    path: '/:id/payment-successful',
    name: 'payment-successful',
    component: PaymentSuccessful
  },
  {
    path: '/terms-and-conditions',
    name: 'terms-and-conditions',
    component: TermsAndConditions
  },
  {
    path: '/faq',
    name: 'faq',
    component:FaqView
  },
  {
    path: '/search',
    name: 'search',
    component: SearchView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  
  routes
})

export default router
